import http from "../../apis/service";
import {instructor, live, login} from "../../apis/endPoint";
import {LIVE_STATUS_CHANGE, LOGIN} from "../index";

export const getLogin = (instructor_id, password) => async dispatch => {
    const response = await http.postWithBody(`${instructor}/${login}`, {
        instructor_id,
        password
    });
    dispatch({
        type: LOGIN,
        payload: response
    });
};


export const changeLiveStatus = (instructor_id, is_live, tuition_config_id) => async dispatch => {
    const response = await http.postWithBody(`${instructor}/${live}`, {
        instructor_id,
        is_live,
        tuition_config_id
    });
    dispatch({
        type: LIVE_STATUS_CHANGE,
        payload: response
    });
};